<div *ngIf="deviceService.tabState && !tabsService.minimizeScreenMode">

  <form #form="ngForm" [ngClass]="['active',  tabsService.fullScreenMode ? 'fullscreen' : '']"
        autocomplete="off" >

    <div id="deviceList" class="fields__block" [style.width]="selectedDevice == null ? '100%' : '50%'">
      <div class="fields__block__section">
        <app-grit-dynamic-table
          (selectedRowEvent)="showDevice($event)"
          [entityName]="'RFI-Transmitter'"
          [tableConfiguration]="DeviceModel.configuration.table"
          [models]="deviceService.devices"
          [preSelected]="selectedDevice?.id"
          [mode]="GritDynamicTableMode.SELECT"
          [type]="GritDynamicTableType.BASIC">
        </app-grit-dynamic-table>

        <h3 *ngIf="!deviceService.devices || deviceService.devices.length == 0">
          No RFI-Transmitters found!
        </h3>
      </div>
    </div>

    <fieldset *ngIf="selectedDevice != null" id="deviceDetails" class="fields__block"
              style="max-height:100%; overflow: scroll"
              [disabled]="!this.gritUserService.allowedGroups(selectedDevice.groupAccess, selectedDevice.groupOriginator)">

      <div class="fields__container__tabs">
        <div class="fields__container__tabs__item" (click)="changeTab(0)">
          <a class="tab-button" [ngClass]="this.tabs[0] ? 'active' : ''">Information</a>
        </div>
        <div class="fields__container__tabs__item" (click)="changeTab(1)">
          <a class="tab-button" [ngClass]="this.tabs[1] ? 'active' : ''">Sectorization</a>
        </div>
      </div>

        <div id="information" class="fields__block__section" [hidden]="!tabs[0]">

          <div class="title">
            <h4>RFI-Transmitter Information</h4><span> </span>
          </div>

          <div class="input-fields">
            <div>
              <label for="name">Name</label>
              <input id="name" type="text" required minlength="0" maxlength="30"
                     [(ngModel)]="selectedDevice.name" name="name"/>
            </div>
          </div>

          <div class="dropdown-fields">
            <div>
              <label for="mainType">Type</label>
              <select id="mainType" required [(ngModel)]="selectedDevice.mainType"
                      (ngModelChange)="changeTargetReceiver()" name="mainType">
                <option *ngFor="let item of DeviceModel.fieldsValues.maintype"
                        [value]="item.value">{{item.display}}</option>
              </select>
            </div>

            <div>
              <label for="subType">Sub-Type</label>
              <select id="subType" required [disabled]="!selectedDevice.mainType"
                      [(ngModel)]="selectedDevice.subType" name="subType">

                <ng-container *ngFor="let item of DeviceModel.fieldsValues.type">
                  <option *ngIf="item.value.startsWith(selectedDevice.mainType)"
                          [value]="item.value.split('/').at(1)">
                    {{item.display.split("/").at(1)}}</option>
                </ng-container>
              </select>
            </div>
          </div>
        </div>

        <div id="technical" class="fields__block__section" [hidden]="!tabs[0]">
          <div class="title">
            <h4>Technical Specifications</h4><span> </span>
          </div>

          <div class="input-fields">
            <div>
              <label>Antenna Polarisation</label>
              <select id="antennaPolarisation" name="antennaPolarisation" required
                      [(ngModel)]="selectedDevice.antennaPolarisation" (ngModelChange)="updateField()">
                <option value="linear">Linear</option>
                <option value="RHCP">RHCP</option>
              </select>
            </div>

            <div>
              <label>Power</label>
              <div class="coordenates">
                <div>
                  <input id="power_dBW" type="number" name="power_dBW"
                         [disabled]="selectedDevice.userDefined != 'power'"
                         [required]="selectedDevice.userDefined == 'power'"
                         [(ngModel)]="selectedDevice.power.dBW"
                         (ngModelChange)="updateField()" style="width: 30%;"
                  /><span>[dBW]</span>
                  <input id="power_dBm" type="number" name="power_dBm"
                         [disabled]="selectedDevice.userDefined != 'power'"
                         [required]="selectedDevice.userDefined == 'power'"
                         [(ngModel)]="selectedDevice.power.dBm"
                         (ngModelChange)="updateField()" style="width: 30%;"
                  /><span>[dBm]</span>
                </div>
              </div>
            </div>

            <div>
              <label for="range">Maximum Potential Range</label>
              <input id="range" type="number" name="range"
                     [disabled]="selectedDevice.userDefined != 'range'"
                     [required]="selectedDevice.userDefined == 'range'"
                     [(ngModel)]="selectedDevice.range"
                     (ngModelChange)="updateField()"
              /><span>[NM]</span>
            </div>

            <div>
              <label for="frequency">Frequency</label>
              <input id="frequency" type="number" name="frequency" required
                     [(ngModel)]="selectedDevice.frequency"
                     (ngModelChange)="updateField()"
              /><span>[GHz]</span>
            </div>

            <div>
              <label for="verticalGain">Vertical Gain</label>
              <input id="verticalGain" type="number" name="verticalGain" required
                     [(ngModel)]="selectedDevice.verticalGain"
                     (ngModelChange)="updateField()"
              /><span>[dBi]</span>
            </div>
          </div>
        </div>

        <div id="target_receiver" class="fields__block__section" [hidden]="!tabs[0]">
          <div class="title">
            <h4>Target Receiver</h4><span> </span>
          </div>

          <ng-container *ngIf="targetReceiver != null">
            <div class="input-fields">
              <div>
                <label>Threshold</label>
                <div class="coordenates">
                  <div>
                    <input id="power_receiver_dBW" type="number" name="power_receiver_dBW"
                           disabled [value]="targetReceiver.threshold.dBW" style="width: 30%;"
                    /><span>[dBW]</span>
                    <input id="power_receiver_dBm" type="number" name="power_receiver_dBm"
                           disabled [value]="targetReceiver.threshold.dBm" style="width: 30%;"
                    /><span>[dBm]</span>
                  </div>
                </div>
              </div>
              <div>
                <label for="receiverGain">Gain</label>
                <input id="receiverGain" type="number" name="receiverGain" required
                       disabled [value]="targetReceiver.gain"
                /><span>[dBi]</span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="targetReceiver == null">
            <p>Target receiver undefined. Computed fields and Sectorization Display unavailable.</p>
          </ng-container>
        </div>

        <grit-groups [hidden]="!tabs[0]"
          [(accessGroup)]="selectedDevice.groupAccess"
          [(originatorGroup)]="selectedDevice.groupOriginator"
          [(visibilityGroup)]="selectedDevice.groupVisibility">
        </grit-groups>


        <div id="sectorization" class="fields__block__section" [hidden]="!tabs[1]">
          <div class="table-fields">
            <div>
              <div>
                <table>
                  <thead>
                  <tr>
                    <th>Type</th>
                    <th>Power [dBW]</th>
                    <th>Gain [dBi]</th>
                    <th>Min Azimuth [deg]</th>
                    <th>Max Azimuth [deg]</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    mdbTableCol
                    *ngFor="let el of selectedDevice.sectorizations; index as i"
                    (click)="el.selected = !el.selected"
                    [class.deleted]="el.deleted && !el.selected"
                    [class.highlighted]="el.selected"
                  >
                    <td>{{ el.type }}</td>
                    <td>{{ el.power.dBW }}</td>
                    <td>{{ el.gain }}</td>
                    <td>{{ el.minAngle }}</td>
                    <td>{{ el.maxAngle }}</td>
                  </tr>
                  </tbody>
                </table>
                <div class="btn">
                  <a (click)="addSectorizationTrigger()">Add Sector</a>
                  <a (click)="deleteSectorizations()">Delete Sector</a>
                  <a (click)="displaySectorizations()" *ngIf="targetReceiver != null">Sectorization Display</a>
                </div>
              </div>
            </div>
          </div>
        </div>

    </fieldset>

    <div class="fields__btn">
      <ng-container *ngIf="this.gritUserService.allowedRoles(GritUserRoleGroup.FullUser)">
        <ng-container *ngIf="selectedDevice != null &&
          this.gritUserService.allowedGroups(selectedDevice.groupAccess, selectedDevice.groupOriginator)">

          <button (click)="saveDevice()" [disabled]="!form.form.valid || !groupsNotNull(selectedDevice)" [ngClass]="form.form.valid && groupsNotNull(selectedDevice)  ? 'blue' : 'gray'">
            {{ selectedDevice?.id == 0 ? 'Create' : 'Save'}}</button>

          <button (click)="deleteDevice()"
                  *ngIf="selectedDevice?.id != 0 && this.gritUserService.allowedGroups(selectedDevice.groupOriginator)"
                  class="white">Delete</button>
        </ng-container>

        <button (click)="addDevice()"
                *ngIf="selectedDevice == null && this.gritUserService.allowedRoles(GritUserRoleGroup.FullUser)"
                class="blue" type="button" value="New">Add</button>
      </ng-container>

      <button (click)="selectedDevice == null ? tabsService.closeTab() : selectedDevice = null" class="gray" type="button">Cancel</button>
    </div>
  </form>
</div>
